import * as React from "react";
import { CardDetailsParams } from "../../../../../typings/CardDetailsParams";
import { renderSportIcon } from "../../EventCard";
import { renderEventName } from "./renderEventName";

export const renderOutrightDetails = (props: CardDetailsParams, componentPrefix: string) => {
    const classNames = `rj-ev-list__${componentPrefix}__section rj-ev-list__${componentPrefix}__event-info`;

    return (
        <a href={props.event.linkUrl}
            onClick={props.handlers.eventCard}
            className={classNames}
            key={`${componentPrefix}__event-info__${props.event.id}`}
            data-uat={`a-ev-list-${componentPrefix}-event-info`}>

            {props.isDesktop && <div className={`rj-ev-list__${componentPrefix}__section-item rj-ev-list__${componentPrefix}__clock`} data-uat={`div-ev-list-${componentPrefix}-clock`}>
                {renderSportIcon(props.event.sportId)}
            </div>}

            <div className={`rj-ev-list__${componentPrefix}__section-item rj-ev-list__${componentPrefix}__names`} data-uat={`div-ev-list-${componentPrefix}-names`}>
                {renderEventName(props.event, componentPrefix)}
            </div>

            <div className={`rj-ev-list__${componentPrefix}__section-item rj-ev-list__${componentPrefix}__market-count`} data-uat={`div-ev-list-${componentPrefix}-market-count`}>
                <span className={`rj-ev-list__${componentPrefix}__market-count-number`} data-uat={`span-ev-list-${componentPrefix}-market-count-number`}>{props.markets[0].selections.length}</span>
                <span className={`rj-ev-list__${componentPrefix}__market-count-arrow`} data-uat={`span-ev-list-${componentPrefix}-market-count-arrow`}></span>
            </div>
        </a>
    );
};